// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_CONTACT_MESSAGE_DIALOG_OPENER = "Ahoj. D\u011bkuji za z\u00e1jem. Poj\u010fme se domluvit.:-)";
export const BZ2_CONTACT_MESSAGE_WAS_SENT = "Zpr\u00e1va byla odesl\u00e1na.";
export const BZ2_JUST_SEND_MESSAGE = "Po\u0161li zpr\u00e1vu";
export const BZ2_SEND_MESSAGE = "Po\u0161li zpr\u00e1vu prodejci";
export const BZ_CONTACT_SEND_NEXT_MESSAGE = "Po\u0161li dal\u0161\u00ed zpr\u00e1vu";
export const BZ_CONTACT_SHOW_COMMUNICATION_WITH_SELLER = "Zobraz komunikaci s prodejcem";
